module.exports = __webpack_public_path__ + "img/13.d00b3cc2.jpg";